module.exports = __webpack_public_path__ + "img/virtue-innovations-logo.97de2f4d.png";